import { Provider } from '@angular/core'
import { CreateGameSetupService, GameSetupConfig } from 'game-setup-services'
import { gameSetupConfigToken } from './game-setup-config.token'

export const createGameSetupServiceProvider: Provider = {
  provide: CreateGameSetupService,
  useFactory: (gameSetupConfig: GameSetupConfig): CreateGameSetupService => {
    return new CreateGameSetupService(gameSetupConfig)
  },
  deps: [gameSetupConfigToken],
}
